/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTaskRequest} from '@cash-web/protos/squareup/stafftasks/endpoints/update-task.pb'
import {UpdateTaskResponse} from '@cash-web/protos/squareup/stafftasks/endpoints/update-task.pb'


export const updateTask = (request: UpdateTaskRequest, options?: CashRequestOptions) => post<UpdateTaskRequest, UpdateTaskResponse>("/proxy/services/squareup.stafftasks.service.StaffTasksService/UpdateTask", request, {...options, rejectOnError: true })